<template>
  <v-container id="docForm" style="max-width: 1500px">
    <!-- first card -->
    <v-card>
      <v-toolbar dense flat color="secondary">
        <v-toolbar-title>
          <v-btn color="primary" icon :to="`/customer/order`">
            <v-icon left>mdi-keyboard-backspace</v-icon>
          </v-btn>Order Creation
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text color="accent" style="margin-right: 40px; margin-top: 10px" to="/customer/order/submit/new">
            <v-badge  color="green" :content="cart.length">My Cart</v-badge>
        </v-btn>
       
      
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-text-field label="Search" v-model="search" outlined dense></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-data-table
              :loading="loader"
              :mobile-breakpoint="0"
              loading-text="Loading Products........"
              :items-per-page="1000"
              :headers="headers"
              :items="products"
              :search="search"
            >
              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn small color="editIcon" text @click="openModal(item)">
                  <v-icon>mdi-cart</v-icon>Add To Cart
                </v-btn>
              </template>
              <!-- end -->

              <!-- action template -->
              <template v-slot:item.price="{ item }">{{item.price.toLocaleString()}}</template>
              <!-- end -->
            </v-data-table>
          </v-col>
        </v-row>

          <!-- product dialog modal-->
          <v-dialog v-model="orderDialog" max-width="550px">
          <v-card>
            <v-toolbar dense color="primary" dark>
              <v-toolbar-title> Order Item</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="orderDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container fluid>
                <v-row class="text--primary subtitle-2">

                  <v-col cols="12">
                    <span style="font-size: 20px">{{ productItem.Name }}</span>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-text-field label="Qty" v-model="qty" outlined dense></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6">
                   <span style="font-weight: bold; font-size: 16px">Price: {{productItem.price && productItem.price.toLocaleString()}}</span>
                  </v-col>

                  <v-col cols="12" md="6">
                   <span style="font-weight: bold; font-size: 16px">Total: {{total && total.toLocaleString()}}</span>
                  </v-col>


                  <v-col cols="12">
                    <v-btn
                        @click="addToCart"
                      color="blue-grey darken-2"
                      dark
                      >Add To cart</v-btn
                    >
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- end of modal-->
      </v-card-text>
    </v-card>
  </v-container>
</template>
  
  <script>
import { mapGetters } from "vuex";
export default {
  components: {

  },
  computed: {
    ...mapGetters(["cart"]),
    activeStore() {
      return localStorage.getItem("store_id");
    },
    total() {
        let qty = 0;
        qty = this.qty;
        let price = 0;
        price = this.productItem.price;
        const total = qty * price;
        return total;
    }
  },
  data: () => ({
    search: "",
    loader: false,
    orderDialog: false,
    taxGroups: [],
    qty: null,
    productItem: {},
    dataItem: {},
    docCreate: true,
    products: [],
    headers: [
      { text: "Code", value: "ItemCode" },
      { text: "Product Name", value: "Name" },
      { text: "Price", value: "price" },
      { text: "Action", value: "action" }
    ]
  }),
  watch: {
    "$route.params.id": {
      handler: "getProducts",
      immediate: true
    }
  },
  methods: {
    openModal(data) {
        this.productItem = data;
        this.orderDialog = true;
    },
    addToCart() {
            let currentItem = {};
            let product = this.productItem;
            currentItem.o_p_l_n_s_id = product.o_p_l_n_s_id;
            currentItem.Quantity = this.qty;
            currentItem.ManualStatus = "Y";
            currentItem.UomEntry = product.SUoMEntry;
            currentItem.ugp1 = [];
            currentItem.o_i_t_m_s_id = product.id;
            currentItem.id = product.id;
            currentItem.Name = product.Name;
            currentItem.store_id = this.activeStore;
            currentItem.PurchaseCurrency = null;
            currentItem.cnvRate = null;
            currentItem.BaseCurrencyTotal = null;
            currentItem.TaxId = this.taxGroups[0].id;
            currentItem.TaxRate = null;
            currentItem.BarCode = null;
            currentItem.ref1 = null;
            currentItem.TaxAmount = null;
            currentItem.BatchID = null;
            const LineNum = new Date().getTime();
            currentItem.LineNum = LineNum;
            currentItem.DiscSum = null;
            currentItem.bp = 0;
            currentItem.available = 0;
            currentItem.Price = product.price;
            currentItem.currentPrice = product.price;
            currentItem.LineTotal = this.total;

            this.$store.commit("addToCart", currentItem);
            this.qty = null;
            this.orderDialog = false;
    },
    getProducts(val) {
      console.log(val, "cat");
      const self = this;
      this.$store
        .dispatch("get", `/category-products/${val}`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.products = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getTaxes() {
        const self = this;
        this.$store.dispatch("get", `/taxgroups/O`).then((res) => {
        if (res.ResultCode == 1200) {
          self.taxGroups = res.ResponseData;
        }
    });
    }
  },
  created() {
    this.getTaxes();
  }
};
</script>